import React, { PureComponent, Fragment } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import Modal from "app/modules/common/component/Modal";
import * as c from "../constant";
import Select from "react-select";
import { isThisSecond } from "date-fns";

class AddUpdateGovDocs extends PureComponent {
  state = {
    reason: "",
    reason_other: "",
  };

  handleOnClose = (e) => {
    e.preventDefault();
    const { dispatch } = this.props;
    dispatch({
      type: "MODAL",
      data: {
        isOpen: false,
      },
    });
  };

  handleChangeSelect = (key) => (value) => {
    this.setState({
      [key]: value,
    });
  };

  handleOnChange = (e) => {
    const { name, value } = e.target;
    this.setState({
      [name]: value,
    });
  };

  handleOnSubmit = (e) => {
    e.preventDefault();
    const { dispatch, form_data } = this.props;
    dispatch({
      type: c.REMOVE_ACCOUNT,
      args: {
        reason:
          this.state.reason === "other"
            ? this.state.reason_other
            : this.state.reason,
      },
    });
  };

  render() {
    const { isLoading } = this.props;
    return (
      <div>
        <form onSubmit={this.handleOnSubmit}>
          <Modal.Body>
            <div className="row">
              <div className="col-12 mb-3">
                <div className="text-center font-weight-bold">
                  Are you sure you want to remove your account?
                </div>
              </div>
            </div>
            <div className="row">
              <div className="input-group col-md-12 col-lg-12 col-12 p-0">
                <label className="col-12 col-form-label">
                  Reason to remove account:
                </label>
                <div className="col-12">
                  <Select
                    required
                    className=""
                    value={this.state.reason}
                    simpleValue
                    onChange={this.handleChangeSelect("reason")}
                    name="reason"
                    loadingPlaceholder="Loading..."
                    options={[
                      {
                        label: "Position already closed",
                        value: "Position already closed",
                      },
                      {
                        label: "Email address issues",
                        value: "Email address issues",
                      },
                      {
                        label: "No longer interested",
                        value: "No longer interested",
                      },
                      {
                        label: "Others: Please specify",
                        value: "other",
                      },
                    ]}
                    placeholder="Select "
                  />
                </div>
              </div>
            </div>
            {this.state.reason === "other" && (
              <div className="row">
                <div className="input-group col-md-12 col-lg-12 col-12 p-0">
                  <label className="col-12 col-form-label">
                    Input your reason
                  </label>
                  <div className="col-12">
                    <input
                      type="text"
                      name="reason_other"
                      className="form-control"
                      value={this.state.reason_other}
                      onChange={this.handleOnChange}
                      required
                    />
                  </div>
                </div>
              </div>
            )}

            <div className="row">
              <div className="col-12 mt-5">
                <div className="d-flex flex-row-reverse">
                  <button
                    className="btn btn-danger btn-md"
                    onClick={this.handleOnClose}
                    disabled={isLoading}
                  >
                    Cancel
                  </button>
                  <button
                    className="btn btn-primary btn-md"
                    onClick={this.printDiv}
                    disabled={isLoading}
                  >
                    {isLoading && (
                      <div
                        class="spinner-border spinner-border-sm mr-2"
                        role="status"
                      >
                        <span class="sr-only">Loading...</span>
                      </div>
                    )}
                    Remove Account
                  </button>
                </div>
              </div>
            </div>
          </Modal.Body>
        </form>
      </div>
    );
  }
}

const mapPropsToState = (state, props) => {
  const profile = state.auth.get("profile");
  const govdocs = state.govdocs.get("list");
  const education = state.education.get("list");
  const work = state.employment.get("list");
  const training = state.training.get("list");
  const reference = state.characterReference.get("list");
  const { loadingTypes } = state.loading;

  return {
    isLoading: loadingTypes.length > 0,
    profile,
    govdocs,
    education,
    work,
    training,
    reference,
  };
};

export default withRouter(connect(mapPropsToState)(AddUpdateGovDocs));
